import { render, staticRenderFns } from "./use-protocol.vue?vue&type=template&id=35dad9b6&scoped=true&"
import script from "./use-protocol.vue?vue&type=script&lang=js&"
export * from "./use-protocol.vue?vue&type=script&lang=js&"
import style0 from "./use-protocol.vue?vue&type=style&index=0&id=35dad9b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dad9b6",
  null
  
)

export default component.exports